export  const appComponet = {
     HOTEL_CITY : "HOTEL_CITY",
     FILTER_PRICE : "FILTER_PRICE",
     FILTER_FREE_CANCELLATION : "FILTER_FREE_CANCELLATION",
     FILTER_WIFI : "FILTER_WIFI",
     FILTER_KITCHEN : "FILTER_KITCHEN",
     FILTER_WASHING_MACHINE : "FILTER_WASHING_MACHINE",
     FILTER_AIR_CONDITIONING : "FILTER_AIR_CONDITIONING",
     FILTER_POOL : "FILTER_POOL",
     FILTER_FREE_PARKING : "FILTER_FREE_PARKING",
     AUTH_LOGIN : "AUTH_LOGIN",
     ID : "ID",
     GUEST : "GUEST",
     NIGHT_STAY : "NIGHT_STAY"
}